exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-users-component table {\n  min-width: 1000px !important;\n}", ""]);

// exports
